<template>
  <b-form @submit="onSubmit">
    <b-card no-body v-if="physical_person" class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b class="text-secondary">Editando Pessoa Física</b>
          <div class="d-flex flex-row-reverse">
            <b-button
              v-if="$can('physical_people:edit')"
              type="submit"
              variant="primary"
            >
              Salvar</b-button
            >
            <router-link
              :to="{
                name: 'physical_people_list',
              }"
              class="btn btn-outline-muted mr-2"
              >Cancelar</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" :cpf_invalid="cpf_invalid" />
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.endereco"
            />
            Endereço
          </template>
          <Endereco ref="endereco" />
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.contatos"
            />
            Contatos
          </template>
          <Contatos ref="contatos" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import DadosBasicos from "./Form/DadosBasicos.vue";
import Endereco from "./Form/Endereco.vue";
import Contatos from "./Form/Contatos.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos, Endereco, Contatos },
  data: () => ({
    cpf_invalid: null,
    validations: {
      dados_basicos: true,
      endereco: true,
      contatos: true,
    },
  }),
  computed: {
    ...mapState("physical_people", ["physical_person"]),
  },
  methods: {
    ...mapActions("physical_people", ["ActionSave"]),

    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSave(this.physical_person);
          this.$emit("saved", this.physical_person.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          for (var i in error.data.errors) {
            if (i == "cpf") {
              this.cpf_invalid = this.physical_person.cpf;
            }
          }
          this.$notifications.addNotification({
            message: error_message,
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      this.validations.endereco = this.$refs.endereco.isValid();
      this.validations.contatos = this.$refs.contatos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
  },

  created() {},
};
</script>

<style></style>
